module.exports = __webpack_public_path__ + "img/unflag-1.0841b18c.svg";